export default __webpack_public_path__ + "static/media/shopify.534b2be9.svg";